import { ISideDrawerTranslation } from 'components/SideDrawer';

export const sideDrawer: ISideDrawerTranslation = {
  dashboard: 'Dashboard',
  master: 'Master',
  users: 'Users',
  customers: 'Customers',
};
